import L from 'leaflet';
import omnivore from '@mapbox/leaflet-omnivore';

export default class Map {

	static #map;
	static #filteredMap;

	constructor() {
		Map.map();
		Map.add_kml();
	}

	static map() {
		Map.map_api('[data-id="wpiris-map"]');
		Map.filtered_map_api('[data-id="wpiris-filtered-map"]')
	}

	static map_api($element) {
		if ($($element).length > 0) {
			let marker_bounds = [],
				markers = [],
				$markers = $($element).find('[data-id="wpiris-map-marker"]');

			Map.#map = L.map('map', {
				center: [
					parseFloat(Theme.latitude),
					parseFloat(Theme.longitude)
				],
				zoom: 12,
				scrollWheelZoom: false
			});

			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
			}).addTo(Map.#map);

			$.each($markers, function (index, data) {

				let marker_icon = L.icon({
					iconUrl: Theme.theme_url + '/assets/dist/images/markers/marker.svg',
					iconSize: [
						30,
						30
					]
				});

				let marker = L.featureGroup()
					.addLayer(L.marker([
						parseFloat($(this).data('lat')),
						parseFloat($(this).data('lng'))
					], {icon: marker_icon}))
					.bindPopup($(this).html(), {
						className: 'light',
						autoPanPadding: L.point(30, 30),
					})
					.addTo(Map.#map);

				markers.push(marker);

				marker_bounds.push([
					parseFloat($(this).data('lat')),
					parseFloat($(this).data('lng'))
				]);

			});

			let group = L.featureGroup(markers);
			Map.#map.fitBounds(group.getBounds(), {padding: [50, 100]});
		}
	}

	static add_kml() {
		let element = "[data-id='wpiris-kml-file']";

		if ($(element).length > 0) {
			let kml = $(element).attr('data-kml');

			let customLayer = L.geoJson(null, {
				style: function (feature) {
					return {color: '#000'};
				}
			});

			let runLayer = omnivore.kml(kml, null, customLayer).addTo(Map.#map);

			runLayer.on('ready', function () {
				Map.#map.fitBounds(runLayer.getBounds());
			});
		}
	}

	static filtered_map_api(elem) {
		$(elem).each(function () {
			const markers = $(this).find('[data-id="wpiris-map-marker"]');
			const groups = [];
			const filteringGroups = [];
			const initBoundary = [];

			// Generate map
			Map.#filteredMap = L.map('filteredMap', {
				center: [
					parseFloat(Theme.latitude),
					parseFloat(Theme.longitude)
				],
				zoom: 11,
				scrollWheelZoom: false
			});

			Map.#filteredMap.zoomControl.setPosition('bottomright');

			L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
				attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
			}).addTo(Map.#filteredMap);

			// Markers layers groups
			markers.each(function () {
				let marker = $(this);

				// If marker has filterable attribute
				if (marker.data('filter')) {
					// Iterate new array level if needed
					if (!groups[marker.data('filter')]) {
						groups[marker.data('filter')] = [];
					}

					// Generate marker icon
					let marker_icon = L.icon({
						iconUrl: Theme.theme_url + '/assets/dist/images/markers/marker.svg',
						iconSize: [
							27,
							36
						]
					});

					// Generate marker and bind it popup
					let markerItem = L
						.featureGroup()
						.addLayer(L.marker([
							parseFloat(marker.data('lat')),
							parseFloat(marker.data('lng'))
						], {icon: marker_icon}))
						.bindPopup(marker.html(), {
							className: 'light',
							autoPanPadding: L.point(27, 36),
						});

					initBoundary.push(markerItem);
					groups[marker.data('filter')].push(markerItem);
				}
			});

			if (initBoundary.length) {
				const boundaryGroup = L.featureGroup(initBoundary);
				Map.#filteredMap.fitBounds(boundaryGroup.getBounds(), {padding: [50, 100]});
			}

			markers.each(function () {
				const marker = $(this);
				const group = L.featureGroup(groups[marker.data('filter')]).addTo(Map.#filteredMap);

				// Add to filtering groups for controls
				filteringGroups[marker.data('filter')] = group;
			});

			Map.bind_filters(filteringGroups);
		});
	}

	static bind_filters(filteringGroups) {
		const filters = $('[data-id="wpiris-map-filters"]');
		const filtersTrigger = $('.interactiveMapFiltersTrigger');

		filtersTrigger.click(function () {
			filters.toggleClass('_active');
		});

		$(filters).each(function () {
			const items = $(this).find('[data-id="wpiris-map-filters-item"] [type="checkbox"]');
			const reset = $(this).find('[type="reset"]');

			reset.click(function () {
				items.each(function () {
					$(this).prop('checked', false);
				})
				filterAction(items);
			});

			items.change(function () {
				filterAction(items);
			});
		});

		const filterAction = function (items) {
			const boundary = [];
			let oneChecked = false;

			// Reset all
			$(filteringGroups).each(function (i, layer) {
				if (layer) {
					layer.removeFrom(Map.#filteredMap);
				}
			});

			// Then add only needed
			items.each(function () {

				if ($(this).is(':checked')) {
					oneChecked = true;
				}

				if ($(this).is(':checked') && filteringGroups[$(this).val()]) {

					filteringGroups[$(this).val()].addTo(Map.#filteredMap);

					// Add setted markers to boundary
					$(filteringGroups[$(this).val()]).each(function (i, marker) {
						if (marker) {
							boundary.push(marker);
						}
					});
				}
			});

			if (!oneChecked) {
				$(filteringGroups).each(function (i, layer) {
					if (layer) {
						layer.addTo(Map.#filteredMap);
						$(layer).each(function (i, marker) {
							if (marker) {
								boundary.push(marker);
							}
						});
					}
				});
			}

			if (boundary.length) {
				const group = L.featureGroup(boundary);
				Map.#filteredMap.fitBounds(group.getBounds(), {padding: [50, 100]});
			}
		}
	}
}
